import { buildVersion } from './build.version';

export const environment = {
  name: 'qa',
  production: false,
  version: buildVersion + '-QA',
  clientId: 'e5e7db35-78ec-49d9-bb72-82591cfe516d',

  // ApiGateway URLs
  dataCleanerUrl: 'https://api-datacleaner.kyloe.plus/qa',
  dataRulesUrl: 'https://api-datarules.kyloe.plus/qa',
  dataToolsUrl: 'https://api-datatoolsadmin.kyloe.plus/qa',
  duplikitUrl: 'https://api-duplikit.kyloe.plus/qa',
  metaDataUrl: 'https://api-datarules.kyloe.plus/qa',
  webSocketUrl: 'wss://datarules-qa.kyloe.plus',

  kyloeAuthHost: 'https://api-auth.kyloe.cloud/qa/authenticate/callback',
  featureFlagsUrl: 'https://platform-dev.kyloe.io/feature-flags/api/v1/client-init',
  ffApiKey: 'Kv5tiKDe4i8O7jFYZz5wNawc3d3hqJ8L7KlKXTRa',
  enableAnalytics: true,

  // AWS RUM Config
  guestRoleArn: 'arn:aws:iam::393399738482:role/RUM-Monitor-eu-west-1-393399738482-4366362306761-Unauth',
  identityPoolId: 'eu-west-1:142a7ff9-34a9-4b97-8356-9d5aa1d1cfa3',
  APPLICATION_ID: 'd6d12a20-f5a4-42bd-bacc-e96db7c375d7',

  // Google Analytics Config
  googleAnalytics: 'G-1MR5M2BL0E',
  googleAnalyticsDTLite: 'G-2X20V5Q5TN',

  // Pendo
  pendoAPIKey: '7ce6958c-9e57-49f7-7905-76e0164d6042'
};
